import React, { useMemo, useCallback } from 'react';
import { Linking, Alert } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAppSelector } from '@/store';
import { UserType } from '@/types/residents/user';
import { FAQContent } from '@/components/residents/redesign';

import { FaqSection, faqSectionsGuarantor, faqSectionsResident } from '@/screens/residents/faq/faq';

const SUPPORT_EMAIL = 'support@resio.com';

export const ResidentFAQScreen: React.FC = () => {
  const insets = useSafeAreaInsets();
  const { user } = useAppSelector((s) => s.auth);

  const sections = useMemo<FaqSection[]>(() => {
    if (!user) return faqSectionsResident;
    return user.type === UserType.RESIDENT ? faqSectionsResident : faqSectionsGuarantor;
  }, [user]);

  const onSupportPress = useCallback(async () => {
    const mailtoUrl = `mailto:${SUPPORT_EMAIL}`;
    try {
      const canOpen = await Linking.canOpenURL(mailtoUrl);
      if (canOpen) {
        await Linking.openURL(mailtoUrl);
      } else {
        Alert.alert('Contact Support', `Please email us at ${SUPPORT_EMAIL}`, [{ text: 'OK' }]);
      }
    } catch {
      Alert.alert('Contact Support', `Please email us at ${SUPPORT_EMAIL}`, [{ text: 'OK' }]);
    }
  }, []);

  return (
    <FAQContent
      sections={sections}
      onSupportPress={onSupportPress}
      contentPaddingBottom={40 + insets.bottom}
    />
  );
};

export default ResidentFAQScreen;
